import m from "../../es2015/lang/hu_HU";
window.am4lang_hu_HU = m;


//////////////////
// WEBPACK FOOTER
// ./lang/hu_HU.js
// module id = null
// module chunks = 